import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const QuillViewerWrapper = styled('div')`
  .ql-container {
    border: 0 !important;
    font-size: 16px;
  }
  .ql-editor {
    padding: 0 !important;
    line-height: 32px;
    iframe.ql-video {
      width: 100%;
      height: 400px;
    }
    h1 {
      strong {
        font-weight: normal;
      }
      font-family: 'Pretendard-Bold';
      font-size: 22px;
      line-height: 32px;
      font-weight: normal;
      color: #333333;
    }
    h2 {
      strong {
        font-weight: normal;
      }
      font-weight: normal;
      font-family: 'Pretendard-SemiBold';
      font-size: 20px;
      line-height: 32px;
      color: #333333;
    }
    p {
      color: #333333;
      ${media.desktop} {
        line-height: 30px;
      }
      ${media.mobile} {
        line-height: 28px;
      }
    }
    .bigMyeongjoFont {
      font-family: 'Nanum Myeongjo';
      font-size: 32px;
      color: #333333;
      display: inline-block;
    }
    .quill-caption {
      font-size: 12px;
      line-height: 16px;
      color: #aa999d;
      display: block;
      margin-top: 7px;
      vertical-align: top;
      margin-top: 7px;
      margin-bottom: 7px;
      text-align: center;
      input {
        width: 100%;
        text-align: center;
        outline: none;
        border: none;
        padding: 0;
      }
    }
    .dividertitle {
      font-weight: bold;
      padding: 15px 0 14px;
      margin: 17px 0 16px;
      border-top: 1px solid #444446;
      border-bottom: 1px solid #ebebeb;
    }
    .dividerline {
      border: none;
      color: #111;
      letter-spacing: 2em;
      text-align: center;
      box-sizing: border-box;
      height: 30px;
      padding: 12px 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }
    .dividerline:before {
      content: '......';
      color: white;
      border-bottom: 1px solid #333333;
      height: 16px;
      position: absolute;
      top: 0px;
    }
    figure.ql-card-figure {
      /* display: inline-flex; */
      display: block;
      flex-direction: column;
      text-align: center;
      margin: auto;
      ${media.mobile} {
        display: block !important;
        float: none !important;
        margin: auto !important;
        padding: 0 !important;
        img {
          width: 100%;
          max-width: 100%;
        }
      }
      .quill-caption {
        margin-bottom: 0px;
      }
    }
    figure.ql-card-figure-left,
    figure.ql-card-figure-right {
      ${media.mobile} {
        margin-bottom: 28px !important;
      }
    }
    figure.no-figcap {
      margin: auto;
    }
    figure.no-figcap + p {
      br {
        display: none;
      }
    }
    .foot-note {
      display: inline-block;
      cursor: pointer;
      color: #ff5500;
      text-decoration: underline;
    }
  }
`;

export default QuillViewerWrapper;
